import React from "react";
import { ArrowRight } from "lucide-react";

const steps = [
  { number: "01", title: "Tell us about your clinic", detail: "Share your location, team size and current workflow." },
  { number: "02", title: "Explore the product", detail: "We will walk through the features relevant to your practice and discuss setup needs." },
  { number: "03", title: "Shape the next version", detail: "Try the product in your clinic and share feedback directly with our team." },
];

const Pilot = () => (
  <section id="pilot" className="cvx-section cvx-pilot overflow-hidden">
    <div className="container mx-auto px-5 sm:px-8 relative z-10">
      <div className="grid lg:grid-cols-2 gap-8 lg:gap-20 items-end mb-14">
        <div>
          <p className="text-emerald-200 text-xs uppercase tracking-[0.18em] font-bold mb-5">Founders pilot</p>
          <h2 className="cvx-section-title !text-white">Build a better clinic day with us.</h2>
        </div>
        <p className="text-lg leading-relaxed text-emerald-50/80 max-w-xl">
          We are inviting a small group of independent veterinary clinics in
          the Gulf to a 30 day pilot. Selected clinics can explore the product
          with guided setup and agreed data migration at no charge. We will
          confirm the scope and any terms for continued use before they join.
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-4 mb-12">
        {steps.map((step) => (
          <article key={step.number} className="cvx-pilot-card">
            <span className="text-emerald-200 text-sm font-semibold">{step.number}</span>
            <h3 className="text-xl font-semibold text-white mt-8 mb-3">{step.title}</h3>
            <p className="text-emerald-50/75 leading-relaxed">{step.detail}</p>
          </article>
        ))}
      </div>
      <a href="/#contact" className="cvx-hero-primary">
        Ask about the pilot <ArrowRight size={19} aria-hidden="true" />
      </a>
    </div>
  </section>
);
export default Pilot;
